function getBannerEl() {
  return document.getElementById('cookies-banner');
}

function hideBanner(res) {
  var el = getBannerEl();
  if (el) el.style.display = 'none';
}

function showBanner() {
  var el = getBannerEl();
  if (el) el.style.display = 'flex';
}

function handleAccept(e) {
  window.Shopify.customerPrivacy.setTrackingConsent(true, hideBanner);

  document.addEventListener('trackingConsentAccepted',function() {
    // console.log('trackingConsentAccepted event fired');
  });
}

function handleDecline() {
  window.Shopify.customerPrivacy.setTrackingConsent(false,hideBanner);
}

function initCookieBanner() {
  const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
  const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

  // console.log("userCanBeTracked== "+userCanBeTracked+" "+"\nuserTrackingConsent== "+userTrackingConsent);

  if(userCanBeTracked && userTrackingConsent === 'no_interaction') {
    showBanner();      
  }
  else
  {
    hideBanner();
  }    
}

window.Shopify.loadFeatures([
  {
    name: 'consent-tracking-api',
    version: '0.1',
  }
],
                            function(error) {
  if (error) {
    throw error;
  }

  initCookieBanner();
});